import { useEffect, useState } from "react";
import { Hourglass, CheckCircle2, XCircle } from "lucide-react";

// Compte à rebours en direct : temps restant à la personne pour VALIDER son invitation
// (avant l'expiration du lien à code ambassadeur personnalisé).
export function InviteCountdown({ expiresAt, validated = false, className = "" }) {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 30000);
    return () => clearInterval(t);
  }, []);

  if (!expiresAt) return null;

  if (validated) {
    return (
      <span className={`inline-flex items-center gap-1 rounded-full bg-emerald-500/15 px-2 py-0.5 text-[11px] font-medium text-emerald-300 ${className}`} data-testid="invite-countdown-validated">
        <CheckCircle2 size={12} /> Invitation validée
      </span>
    );
  }

  const exp = new Date(expiresAt).getTime();
  const diff = exp - now;

  if (!Number.isFinite(exp)) return null;

  if (diff <= 0) {
    return (
      <span className={`inline-flex items-center gap-1 rounded-full bg-destructive/20 px-2 py-0.5 text-[11px] font-medium text-red-300 ${className}`} data-testid="invite-countdown-expired">
        <XCircle size={12} /> Délai de validation expiré
      </span>
    );
  }

  const totalMin = Math.floor(diff / 60000);
  const days = Math.floor(totalMin / (60 * 24));
  const hours = Math.floor((totalMin % (60 * 24)) / 60);
  const mins = totalMin % 60;
  let label;
  if (days > 0) label = `${days} j ${hours} h`;
  else if (hours > 0) label = `${hours} h ${mins} min`;
  else label = `${mins} min`;

  const urgent = diff <= 6 * 3600 * 1000; // < 6h
  const color = urgent ? "bg-amber-400/15 text-amber-300" : "bg-sky-500/15 text-sky-300";

  return (
    <span className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-medium ${color} ${className}`} data-testid="invite-countdown" title={`Expire le ${new Date(expiresAt).toLocaleString("fr-FR")}`}>
      <Hourglass size={12} /> Reste {label} pour valider
    </span>
  );
}

export default InviteCountdown;
